var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":_vm.width,"height":_vm.height,"aria-label":_vm.iconLabel,"viewBox":"0 0 24 24","role":"img"}},[_c('title',[_vm._v(_vm._s(_vm.iconLabel))]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }